<template>
  <div style="padding-top: 90px;" v-loading="loading" element-loading-background="rgba(17, 17, 17, 0.8)">

    <!-- <div style="height: 200px;background-color: #fff;">
      大图
    </div>

    <el-row :span="24" :gutter="0" class="row-bg">
      <el-col :span="6">0</el-col>
      <el-col :span="6">1</el-col>
      <el-col :span="6">2</el-col>
      <el-col :span="6">2</el-col>
    </el-row> -->



    <div style="margin: 0px;">
      <!-- 广告 -->
      <el-row :gutter="0">

        <el-col :xs="12*item.span" :sm="6*item.span" :md="6*item.span" :lg="4*item.span" v-for="(item,index) in PageData.adlist" :key="index"><!-- style="margin-bottom: -10px" -->

          <a :href="item.url" target="_blank">
            <el-image :title="item.title" error="@/assets/no_img.png" style="width: 100%;height: 100%;text-align: center;padding: 0 2px;" class="" :src="item.image" fit="cover" >
              <template #error>
                <div style="background-color: #000;color: #fff;">{{ item.title }}</div>
              </template>
            </el-image>
          </a>

        </el-col>

      </el-row>
    </div>



    <div class="size-body">

      <div>
        <div class="title-s">
          최신 업데이트
        </div>

        <el-row :span="24" :gutter="10">
          <!-- <el-col :sm="24" :md="18" style="padding: 10px;min-height: 200px;" class="row-bg"> -->
          <el-col :span="24" style="padding: 10px;min-height: 200px;" class="row-bg">
            
            <el-row :span="24" :gutter="0">
              <el-col :xs="12" :sm="6" :md="6" :lg="4" class="card" style="position: relative;" :span="4" v-for="(item,index) in PageData.update_list" :key="index" >
                
                  <!-- <span v-if="item.ending==0" class="ending">완결</span>
                  <span v-else class="ending">제 {{ item.ending }} 화</span> -->
                  <span v-if="item.today==1" class="ending">Today</span>
                  

                  <router-link :to="'/Detail?id='+item.id">

                    <el-card shadow="hover" :body-style="{ padding: '0px', width: '100%' }"
                        style="margin: 3px 3px;border: 0;border-radius: 5px;background-color: #000;">
                        <span>
                        <el-image style="width: 100%; aspect-ratio: 9/13;border-radius: 5px 5px 0 0;text-align: center;" :src="item.image" fit="cover">
                            <div slot="error">
                            <img src="@/assets/no_img.png" style="width: 100%; aspect-ratio: 9/13;text-align: center;"
                                fit="cover">
                            </div>
                            <div slot="placeholder">
                            <img src="@/assets/loading.gif" style="width: 100%; aspect-ratio: 9/13;text-align: center;"
                                fit="cover">
                            </div>
                        </el-image>
                        </span>
                        

                        <div style="margin: 0 8px;padding: 3px 0;min-height: 40px;">
                        <el-tooltip transition="" effect="dark" :content="item.intor" placement="top">
                            <div class="one_line" style="color: #ddd;font-size: 0.9rem;width:100%;text-align: left;">
                            <div>{{ item.title }}</div>
                            <div>
                              <!-- {{ item.star }} -->
                              <span v-if="item.ending==0">완결</span>
                              <span v-else>제 {{ item.ending }} 화</span>
                            </div>
                            </div>
                        </el-tooltip>
                        </div>

                    </el-card>

                  </router-link>

              </el-col>
            </el-row>

          </el-col>

          <!-- <el-col :span="6" class="hidden-sm-and-down">
            
            <div style="background-color: #003333;margin-left: 20px;padding: 10px;">

              -- 广告 --
              <div style="margin-bottom: 20px;">

                <el-row :span="24" :gutter="0">

                  <el-col :md="24" :lg="8" v-for="(item,index) in 6" :key="index">
                    
                    <el-image :title="item.title" error="@/assets/no_img.png" style="width: 100%;height: 100%;text-align: center;" class="" :src="'https://images2.imgbox.com/ad/24/ThK9gY2F_o.gif'" fit="cover" >
                      <template #error>
                        <div style="background-color: #000;color: #fff;">{{ item.title }}</div>
                      </template>
                    </el-image>

                  </el-col>

                </el-row>

              </div>
              -- 广告 --
              
              <el-row :span="24" :gutter="0" v-for="(item,index) in PageData.top_list" :key="index">

                <el-col :span="4" class="ranking_num">
                  {{ index + 1 }}
                </el-col>
                <el-col :span="20" class="ranking_title one_line">
                  <router-link :to="'/Detail?id='+item.id">
                    {{ item.title }}
                  </router-link>
                </el-col>

              </el-row>
              

              -- 广告 --
              <div style="margin-top: 25px;">

                <el-row :span="24" :gutter="0">

                  <el-col :md="12" :lg="8" v-for="(item,index) in 12" :key="index">
                    
                    <el-image :title="item.title" error="@/assets/no_img.png" style="width: 100%;height: 100%;text-align: center;" class="" :src="'https://images2.imgbox.com/ad/24/ThK9gY2F_o.gif'" fit="cover" >
                      <template #error>
                        <div style="background-color: #000;color: #fff;">{{ item.title }}</div>
                      </template>
                    </el-image>

                  </el-col>

                </el-row>

              </div>
              -- 广告 --

            </div>

          </el-col> -->
        </el-row>
      </div>

      <div>
        <div class="title-s">
          최신 영화
        </div>

        <el-row :span="24" :gutter="0" style="padding: 10px;min-height: 200px;" class="row-bg">
          <el-col :xs="12" :sm="6" :lg="3" class="card" style="position: relative;" v-for="(item,index) in PageData.movie_list" :key="index" >
            
            <!-- <span v-if="item.ending==0" class="ending">완결</span>
            <span v-else class="ending">제 {{ item.ending }} 화</span> -->
            <span v-if="item.today==1" class="ending">Today</span>
            
            <router-link :to="'/Detail?id='+item.id">

              <el-card shadow="hover" :body-style="{ padding: '0px', width: '100%' }"
                  style="margin: 3px 3px;border: 0;border-radius: 5px;background-color: #000;">
                  <span>
                  <el-image style="width: 100%; aspect-ratio: 9/13;border-radius: 5px 5px 0 0;text-align: center;" :src="item.image" fit="cover">
                      <div slot="error">
                      <img src="@/assets/no_img.png" style="width: 100%; aspect-ratio: 9/13;text-align: center;"
                          fit="cover">
                      </div>
                      <div slot="placeholder">
                      <img src="@/assets/loading.gif" style="width: 100%; aspect-ratio: 9/13;text-align: center;"
                          fit="cover">
                      </div>
                  </el-image>
                  </span>
                  

                  <div style="margin: 0 8px;padding: 3px 0;min-height: 40px;">
                  <el-tooltip transition="" effect="dark" :content="item.intor" placement="top">
                      <div class="one_line" style="color: #ddd;font-size: 0.9rem;width:100%;text-align: left;">
                      <div>{{ item.title }}</div>
                      <div>
                        <!-- {{ item.star }} -->
                        <span v-if="item.ending==0">완결</span>
                        <span v-else>제 {{ item.ending }} 화</span>
                      </div>
                      </div>
                  </el-tooltip>
                  </div>

              </el-card>

            </router-link>

          </el-col>
        </el-row>
      </div>

      <div>
        <div class="title-s">
          최신 드라마
        </div>

        <el-row :span="24" :gutter="0" style="padding: 10px;min-height: 200px;" class="row-bg">
          <el-col :xs="12" :sm="6" :lg="3" class="card" style="position: relative;" v-for="(item,index) in PageData.drama_list" :key="index" >
            
            <!-- <span v-if="item.ending==0" class="ending">완결</span>
            <span v-else class="ending">제 {{ item.ending }} 화</span> -->
            <span v-if="item.today==1" class="ending">Today</span>
            
            <router-link :to="'/Detail?id='+item.id">

              <el-card shadow="hover" :body-style="{ padding: '0px', width: '100%' }"
                  style="margin: 3px 3px;border: 0;border-radius: 5px;background-color: #000;">
                  <span>
                  <el-image style="width: 100%; aspect-ratio: 9/13;border-radius: 5px 5px 0 0;text-align: center;" :src="item.image" fit="cover">
                      <div slot="error">
                      <img src="@/assets/no_img.png" style="width: 100%; aspect-ratio: 9/13;text-align: center;"
                          fit="cover">
                      </div>
                      <div slot="placeholder">
                      <img src="@/assets/loading.gif" style="width: 100%; aspect-ratio: 9/13;text-align: center;"
                          fit="cover">
                      </div>
                  </el-image>
                  </span>
                  

                  <div style="margin: 0 8px;padding: 3px 0;min-height: 40px;">
                  <el-tooltip transition="" effect="dark" :content="item.intor" placement="top">
                      <div class="one_line" style="color: #ddd;font-size: 0.9rem;width:100%;text-align: left;">
                      <div>{{ item.title }}</div>
                      <div>
                        <!-- {{ item.star }} -->
                        <span v-if="item.ending==0">완결</span>
                        <span v-else>제 {{ item.ending }} 화</span>
                      </div>
                      </div>
                  </el-tooltip>
                  </div>

              </el-card>

            </router-link>

          </el-col>
        </el-row>
      </div>


      <div>
        <div class="title-s">
          최신 예능
        </div>

        <el-row :span="24" :gutter="0" style="padding: 10px;min-height: 200px;" class="row-bg">
          <el-col :xs="12" :sm="6" :lg="3" class="card" style="position: relative;" v-for="(item,index) in PageData.et_list" :key="index" >
            
            <!-- <span v-if="item.ending==0" class="ending">완결</span>
            <span v-else class="ending">제 {{ item.ending }} 화</span> -->
            <span v-if="item.today==1" class="ending">Today</span>
            
            <router-link :to="'/Detail?id='+item.id">

              <el-card shadow="hover" :body-style="{ padding: '0px', width: '100%' }"
                  style="margin: 3px 3px;border: 0;border-radius: 5px;background-color: #000;">
                  <span>
                  <el-image style="width: 100%; aspect-ratio: 9/13;border-radius: 5px 5px 0 0;text-align: center;" :src="item.image" fit="cover">
                      <div slot="error">
                      <img src="@/assets/no_img.png" style="width: 100%; aspect-ratio: 9/13;text-align: center;"
                          fit="cover">
                      </div>
                      <div slot="placeholder">
                      <img src="@/assets/loading.gif" style="width: 100%; aspect-ratio: 9/13;text-align: center;"
                          fit="cover">
                      </div>
                  </el-image>
                  </span>
                  

                  <div style="margin: 0 8px;padding: 3px 0;min-height: 40px;">
                  <el-tooltip transition="" effect="dark" :content="item.intor" placement="top">
                      <div class="one_line" style="color: #ddd;font-size: 0.9rem;width:100%;text-align: left;">
                      <div>{{ item.title }}</div>
                      <div>
                        <!-- {{ item.star }} -->
                        <span v-if="item.ending==0">완결</span>
                        <span v-else>제 {{ item.ending }} 화</span>
                      </div>
                      </div>
                  </el-tooltip>
                  </div>

              </el-card>

            </router-link>

          </el-col>
        </el-row>
      </div>


      
      <!-- 友情链接 -->
      <div class="row-bg font_Arial" style="font-size: 13px;text-align: left;margin-top: 20px;padding: 10px;min-height: 200px;">
          
        <el-row :span="24">
          <el-col :xs="12" :sm="6" :lg="4" v-for="(item,index) in PageData.link_list" :key="index">
            
            <div class="s_subTitle">
              <!-- 성인사이트 -->
                {{ item.text }}
            </div>

            <el-container class="scrollbar" style="height: 200px;padding-right: 30px;">
              <el-aside style="width: 100%;">
                
                <div class="linkText" v-for="(link_it,link_in) in item.list" :key="link_in">
                  <div> <a :href="link_it.url" target="_blank" rel="noopener noreferrer">{{ link_it.text }}</a> </div>
                </div>
                
              </el-aside>
            </el-container>

          </el-col>
          
        </el-row>
          
      </div>


    </div>
    
  </div>
</template>

<script>
export default {
  name: 'IndexView',
  components: {

  },
  data(){
    return{
      loading:true,
      PageData:{
        recommend:[],
        adlist:[],
        top_list:[],
        update_list:[],
        movie_list:[],
        drama_list:[],
        et_list:[],
        link_list:[]
      },
    }
  },
  mounted() {
    
    this.loadPage()

  },
  methods: {
    loadPage(){
      var this_ = this

      this.link_list1=[];this.link_list2=[];this.link_list3=[];this.link_list4=[];this.link_list5=[];this.link_list6=[];

      this.httpinfo.GetInfo(this,this.baseURL + "index?mark="+this.baseMark+"&todaytop_limit=12&update_limit=12&movie_limit=8&drama_limit=8&et_limit=8", function(e) {
        if(e.data.code==0){

          this_.PageData = e.data.data
          
          let Temp_Rand_Arr = [],Temp_No_Rand_Arr = []
          this_.PageData.adlist.forEach(function(item){
            if(item.rand=='0'){
              Temp_Rand_Arr.push(item)
            }else{
              Temp_No_Rand_Arr.push(item)
            }
          })
          Temp_Rand_Arr.sort(() => Math.random() - 0.5) //随机位置
          // this_.PageData.adlist = Temp_No_Rand_Arr.concat(Temp_Rand_Arr) //合并数组

          Temp_No_Rand_Arr.forEach(function(item){
            Temp_Rand_Arr.splice(item.location_num-1,0,item)
          })
          this_.PageData.adlist = Temp_Rand_Arr
        }
        this_.loading = false

      });
    }
  }
}
</script>
<style>
.ranking_num{
  font-size: 25px;
  line-height: 40px;
  color: #ffe6e6;
  font-family: 'TSDR';
  font-style: italic;
  font-weight: bold;
}
.ranking_title{
  font-size: 25px;
  line-height: 40px;
  color: #ffbebe;
  font-style: italic;
  font-weight: bold;
}

.s_subTitle {
  color: rgb(216, 157, 37);
  width: 100%;
  text-align: left;
  font-size: 16px;
  font-weight: bold;
  padding: 10px 0 10px 0;
}

.linkText{
  line-height: 25px;
}
</style>
